<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col md="8">
        <b-form-group label-for="v-auxiliar">

          <SearchOpts
            v-model="tempLabAuxiliar"
            :searchService="searchLabByName"
            placeholder="Buscar examen por nombre"
            :minChars="3"
            :omit="[]"
          /> 
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-button
          :disabled="!tempLabAuxiliar"
          variant="warning" 
          size="sm" 
          @click="addListaPrevia()"
          style="cursor: pointer;"
          title="add"
        >
          +
        </b-button>
      </b-col>

      <b-alert 
        variant="secondary" 
        show 
        class="p-2 col-12 mx-1"
        v-if="listaPrevia && listaPrevia.length"
      >
        <h4 class="mb-1">Listado Previo de Examenes a Enviar</h4>
        <div 
          v-for="(item, index) in listaPrevia" 
          :key="index"
          class="mb-1 row d-flex align-items-center"
        >
          <span class="col-5">{{ item.text }}</span>
          <div class="col">
            <b-button
              variant="danger"
              size="sm"
              @click="onRemoveListaPrevia(index)"
            >x</b-button>
          </div>
        </div>
      </b-alert>


      <div class="col-11" v-if="justificacionMismaOrden || justificacionOtrasOrdenes || justificacion">
        <span>Justificacion:</span>

        <b-form-textarea
          v-model="justificacion"
          rows="2"
        />
      </div>

    </b-row>


    <b-row 
      v-if="listaPrevia && listaPrevia.length" 
      class="d-flex align-items-center justify-content-end mt-1"
    >
      <b-col md="2">
        <b-button
          v-if="!indexToEdit"
          variant="primary" 
          size="sm" 
          @click="agregarOrdenAuxiliar()"
          style="cursor: pointer;"
          title="Agregar Laboratorio Auxiliar"
        >
          + Agregar
        </b-button>

        <b-button
          v-if="indexToEdit"
          variant="primary" 
          size="sm" 
          @click="editarOrdenAuxiliar()"
          style="cursor: pointer;"
        >
          Guardar
        </b-button>

      </b-col>

    </b-row>

  </div>
</template>

<script>
import { SearchOpts }         from '@/shared/components';
import { searchLabByName }    from '@/views/atencionCita/helpers/searchLabByName';

export default {

  name: "FormAddLabAux",

  props:{
    examenesAuxiliares: { 
      type: Array, 
      default: () => [] 
    },

    indexToEdit:{
      type: String,
      default:null
    }
  },

  components: {
    SearchOpts,
  },


  created() {
    
    if(this.indexToEdit) this.loadDataToEdit()
  },

  data(){
    return {
      searchLabByName,
      tempLabAuxiliar: null,
      justificacion: null,
      showFieldJustificacion: false,
      justificacionMismaOrden: false,
      justificacionOtrasOrdenes: false,

      listaPrevia:[],


      labToEdit: null
    }
  },


  methods:{

    loadDataToEdit(){
      const labToEdit = { ...this.examenesAuxiliares[this.indexToEdit] }

      this.labToEdit = labToEdit
      this.listaPrevia = [...labToEdit.laboratorios];
      this.justificacion = labToEdit.justificacion;
    },

    addListaPrevia(){
      this.listaPrevia.push(this.tempLabAuxiliar);
      this.tempLabAuxiliar = null;
    },

    onRemoveListaPrevia(index){
      this.listaPrevia.splice(index, 1);
    },


    agregarOrdenAuxiliar() {
      if (!this.listaPrevia || this.listaPrevia.length === 0) {
        this.$swal({
          title: 'Error',
          text : 'Por favor, seleccione un examen antes de agregar.',
          icon : 'error',
          confirmButtonColor: '#089599',
        });

        return;
      } 

      const hayRepetidosListaPrevia = this.validarRepetidosListaPrevia();
      if(hayRepetidosListaPrevia) return;

      const hayRepetidosEnOtrasOrdenes = this.validateRepetidosOtrasOrdenes();
      if (hayRepetidosEnOtrasOrdenes) return;

      const codigoOrden = this.generateCodeDate()

      const nuevaOrden = {
        accion            : "crear",
        estadoLaboratorio : '0',
        codigoOrden       : codigoOrden.toString(),
        laboratorios      : this.listaPrevia,
        justificacion     : this.justificacion,
      };

      this.examenesAuxiliares.push(nuevaOrden);
      this.limpiarFormularioAuxiliar();
    },



    editarOrdenAuxiliar() {
      if (!this.listaPrevia || this.listaPrevia.length === 0) {
        this.$swal({
          title: 'Error',
          text : 'Por favor, seleccione un examen antes de agregar.',
          icon : 'error',
          confirmButtonColor: '#089599',
        });

        return;
      } 

      const hayRepetidosListaPrevia = this.validarRepetidosListaPrevia();
      if(hayRepetidosListaPrevia) return;

      const hayRepetidosEnOtrasOrdenes = this.validateRepetidosOtrasOrdenes();
      if (hayRepetidosEnOtrasOrdenes) return;


      const ordenEditada = {
        ...this.labToEdit,
        accion        : this.labToEdit.accion === 'registrado' ? 'editar' : this.labToEdit.accion,
        laboratorios  : this.listaPrevia,
        justificacion : this.justificacion,
      }

      this.$set(this.examenesAuxiliares, this.indexToEdit, ordenEditada);
      this.limpiarFormularioAuxiliar();
      this.$bvModal.hide('editLabAux');
    },


    generateCodeDate() {
      return new Date().getTime();
    },

    limpiarFormularioAuxiliar() {
      this.listaPrevia = [];
      this.justificacion = null;
      this.justificacionMismaOrden = false;
      this.justificacionOtrasOrdenes = false;
    },


    validarRepetidosListaPrevia(){

      const hayRepetidos = this.listaPrevia.some(
        (item, index, arr) => arr.findIndex(obj => obj.codigo === item.codigo) !== index
      );

      this.justificacionMismaOrden = hayRepetidos;

      if(hayRepetidos && !this.justificacion){
        this.$swal({
          title: 'Advertencia',
          text: 'Examenes repetidos en la misma orden debe ingresar una justificacion.',
          icon: 'warning',
          confirmButtonColor: '#089599',
        });

        return true
      }

      return false;
    },

    validateRepetidosOtrasOrdenes(){

      let idsOtrasOrdenes = [];

      idsOtrasOrdenes = this.examenesAuxiliares
        .map(item => item.laboratorios.map(lab => lab.id))
        .flat();

      if(this.indexToEdit){
        idsOtrasOrdenes = this.examenesAuxiliares
          .map((item, index) => {
            // Ignora la orden actual si estás editando
            if (index == this.indexToEdit) return [];
            return item.laboratorios.map(lab => lab.id);
          })
          .flat();
      }

      const hayRepetidos = this.listaPrevia.some(
        item => idsOtrasOrdenes.includes(item.id)
      );

      this.justificacionOtrasOrdenes = hayRepetidos;

      if (hayRepetidos && !this.justificacion){

        this.$swal({
          title: 'Info',
          text: 'El examen ya esta en lista debera agregar una justificacion.',
          icon: 'warning',
          confirmButtonColor: '#089599',
        });

      }

      return hayRepetidos && !this.justificacion;
    },



    // validateRepetidosOtrasOrdenes(){

    //   if(this.indexToEdit) return false

    //   const idsOtrasOrdenes = this.examenesAuxiliares
    //     .map(item => item.laboratorios.map(lab => lab.id))
    //     .flat();


    //   const hayRepetidos = this.listaPrevia.some(
    //     item => idsOtrasOrdenes.includes(item.id)
    //   );

    //   this.showFieldJustificacion = hayRepetidos;
    //   this.justificacion = this.showFieldJustificacion ? this.justificacion : '';

    //   if (!hayRepetidos) return true;
    //   if(this.justificacion) return true;

    //   this.$swal({
    //     title: 'Info',
    //     text: 'El examen ya esta en lista debera agregar una justificacion.',
    //     icon: 'info',
    //     confirmButtonColor: '#089599',
    //   });

    //   return false;
    // },

  }, 

  watch:{
    listaPrevia:{
      deep: true,
      handler(){
        this.validarRepetidosListaPrevia();
        this.validateRepetidosOtrasOrdenes();
      }
    }
  }

}
</script>
